import { render, staticRenderFns } from "./TreatmentCourseDetails.vue?vue&type=template&id=3e0b64b0&scoped=true&"
import script from "./TreatmentCourseDetails.vue?vue&type=script&lang=ts&"
export * from "./TreatmentCourseDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TreatmentCourseDetails.vue?vue&type=style&index=0&id=3e0b64b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0b64b0",
  null
  
)

export default component.exports